/* eslint no-unused-vars: 1 */

(function() {
    'use strict';

    angular.module('porting').controller('portingFormCtrl', portingFormCtrl);
    portingFormCtrl.$inject = [ '$rootScope', '$scope', '$location', '$http', '$injector', '$stateParams'
    ];
    function portingFormCtrl($rootScope, $scope, $location, $http, $injector, $stateParams) {
        var vm = this;
        vm.$onInit = function () {
            vm.data = $stateParams.data;
        };

    };
})();
